import { Helmet } from 'react-helmet-async';

/**
 * Zet `VITE_GOOGLE_SITE_VERIFICATION` in .env.production (alleen de waarde uit
 * content="..." van de meta-tag uit Search Console).
 */
export function GoogleSiteVerification() {
  const token = (import.meta.env.VITE_GOOGLE_SITE_VERIFICATION as string | undefined)?.trim();
  if (!token) return null;
  return (
    <Helmet>
      <meta name="google-site-verification" content={token} />
    </Helmet>
  );
}
